import Quiz from "./components";
export default Quiz;